import { Card, CardContent, Box, Typography } from '@mui/material'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import RemoveIcon from '@mui/icons-material/Remove'
import { formatCurrency, formatNumber, formatTrend, DASHBOARD_COLORS, dashboardCardSx } from './dashboardFormatters'

const accentColors = {
  red: DASHBOARD_COLORS.red,
  green: DASHBOARD_COLORS.green,
  amber: DASHBOARD_COLORS.amber,
  blue: DASHBOARD_COLORS.blue,
}

const KpiCard = ({
  title,
  value,
  trend,
  sublabel,
  accent = 'red',
  alert,
  warn,
  onClick,
  currency = false,
}) => {
  const trendInfo = trend != null ? formatTrend(trend) : null
  const TrendIcon =
    trendInfo?.direction === 'up'
      ? TrendingUpIcon
      : trendInfo?.direction === 'down'
        ? TrendingDownIcon
        : RemoveIcon

  return (
    <Card
      sx={{
        ...dashboardCardSx,
        height: '100%',
        cursor: onClick ? 'pointer' : 'default',
        bgcolor: alert ? '#fff8f8' : warn ? '#fffaf2' : '#fff',
        position: 'relative',
        overflow: 'hidden',
        transition: 'box-shadow 0.15s',
        '&:hover': onClick ? { boxShadow: '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.05)' } : undefined,
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 4,
          height: '100%',
          bgcolor: accentColors[accent] || accentColors.red,
        }}
      />
      <CardContent>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
          {title}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700, my: 1 }}>
          {currency ? formatCurrency(value) : formatNumber(value)}
        </Typography>
        {trendInfo && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: trendInfo.direction === 'up' ? 'success.main' : trendInfo.direction === 'down' ? 'error.main' : 'text.secondary' }}>
            <TrendIcon sx={{ fontSize: 16 }} />
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {trendInfo.text} {sublabel || ''}
            </Typography>
          </Box>
        )}
        {!trendInfo && sublabel && (
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            {sublabel}
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export default KpiCard
